module.exports = __webpack_public_path__ + "img/ruler&pen.6aa9a3dd.svg";